<template>
  <v-container>
    <h3>{{ label }}</h3>
    <codemirror :value="xml" @input="changeItem" :options="cmOptions" />
      <v-tooltip left>
        <template v-slot:activator="{ on }">
        <v-btn icon @click="pretty" v-on="on" color="primary">
          <v-icon>mdi-code-tags-check</v-icon>
        </v-btn>
        </template>
        <span>{{$t('core.xmlformatter.beautify')}}</span>
      </v-tooltip>

      <v-tooltip right>
        <template v-slot:activator="{ on }">
        <v-btn icon @click="minify" v-on="on" color="red">
          <v-icon>mdi-code-tags</v-icon>
        </v-btn>
        </template>
        <span>{{$t('core.xmlformatter.minify')}}</span>
      </v-tooltip>
  </v-container>

</template>

<script>
import { codemirror } from 'vue-codemirror'

// base style
import '../../assets/codemirror.css'

// language
import 'codemirror/mode/xml/xml.js'

import 'codemirror/keymap/sublime.js'

import '../../assets/plutao-codemirror.css'

import 'codemirror/addon/selection/active-line.js'
import 'codemirror/addon/fold/xml-fold.js'

export default {
  name: 'XMLFormatter',

  components: {
    codemirror
  },

  data: () => {
    return {
      cmOptions: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        styleSelectedText: false,
        line: false,
        mode: 'text/xml',
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'plutao'
      }
    }
  },

  computed: {
    requiredRules () {
      return this.required && this.xml === ''
        ? [this.$t('warnings.validation.required')]
        : []
    }
  },

  model: {
    prop: 'xml',
    event: 'change'
  },

  props: {
    required: {
      type: Boolean,
      default: false
    },
    xml: {
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },

  methods: {
    pretty () {
      const teste = window.vkbeautify.xml(this.xml, 2)
      this.$emit('change', teste)
    },
    minify () {
      this.$emit('change', window.vkbeautify.xmlmin(this.xml, 2))
    },
    changeItem (event) {
      this.$emit('change', event)
    }
  }
}
</script>
<style>
.CodeMirror-cursor{
  height: 50px;
  width: 20px;
}

.CodeMirror pre.CodeMirror-line-like{
  line-height: 50px;
}
</style>
